import { render, staticRenderFns } from "./BankSlipPhotosUpload.vue?vue&type=template&id=923ec86e&scoped=true&"
import script from "./BankSlipPhotosUpload.vue?vue&type=script&lang=js&"
export * from "./BankSlipPhotosUpload.vue?vue&type=script&lang=js&"
import style0 from "./BankSlipPhotosUpload.vue?vue&type=style&index=0&id=923ec86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923ec86e",
  null
  
)

export default component.exports